/**
 * Orden y texto de las intervenciones del panel del técnico, sin React (se prueban con Jest).
 *
 * Desde el 24/10 una intervención puede estar registrada SIN cita (presencial, teléfono, remoto, Teams):
 * es una fila de citas_tecnicas ya `realizada` y SIN hora (`hora_inicio` NULL). La ordenación de
 * «Pasadas» hacía `b.hora_inicio.localeCompare(...)`: con dos del mismo día y la segunda sin hora,
 * TypeError, y caía el panel entero. Aquí una hora que falta cuenta como '' (va detrás, en orden
 * descendente, de las que la tienen).
 */

const horaDe = (c) => (c && c.hora_inicio ? String(c.hora_inicio) : '');

/** Pasadas, la más reciente primero: por fecha y, dentro del día, por hora. No muta la entrada. */
export function ordenarPasadas(citas) {
  return [...(citas || [])].sort((a, b) => (a.fecha === b.fecha
    ? horaDe(b).localeCompare(horaDe(a))
    : String(b.fecha).localeCompare(String(a.fecha))));
}
